import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import * as typeUtils from "../../../utils/typeUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/parameterAbstract";
import { getParameterReferences } from "./helpers/parameterHelper";

const _action = `${ACTION_PREFIX_PARAMETER}_move_to_functions`;
const _header = `Move parameter`;

export const moveParameterToFunctions = (root, id, idDestinationParent, index) => {
  const _payload = moveParameterToFunctionsLogic(root, id, idDestinationParent, index);

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const moveParameterToFunctionsLogic = (root, id, idDestinationParent, indexDestination) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Parameter to move not found");
  }
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));
  const { data: _nodeDestinationParent } = getNodeById(root, idDestinationParent);
  if (!_nodeDestinationParent) {
    throw new Error("Destination parent node not found");
  }
  const { data: _nodeCopy } = nodeUtils.copy(_node);

  const _indexParsed = indexDestination ?? nodeUtils.getParameters(_nodeDestinationParent).length;

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getParameterReferences(root, _node);

  addParameter(_nodeDestinationParent, _nodeCopy, _indexParsed);
  updateParameter(_nodeCopy, id, idDestinationParent);
  updateReference(_node, _nodeCopy);

  return generatePayload(
    _nodeBackup,
    _index,
    _nodeParent,
    _indexParsed,
    _nodeDestinationParent,
    _nodeCopy,
    _references.description
  );
};

const addParameter = (nodeDestinationParent, nodeCopy, indexDestination) => {
  const funAdd = (e) => e.push(nodeCopy);
  const funPosition = (e) => e.splice(indexDestination, 0, nodeCopy);
  const fun = (e) => (!indexDestination && indexDestination !== 0 ? funAdd(e) : funPosition(e));

  nodeUtils.modifyParameters(nodeDestinationParent, fun, false);
};

const updateParameter = (nodeCopy, id, idDestinationParent) => {
  nodeUtils.setName(nodeCopy, "");
  nodeUtils.setType(nodeCopy, typeUtils.getTypeParameterLinked());
  nodeUtils.setIdTarget(nodeCopy, id);
  nodeUtils.setIdReferences(nodeCopy, null);
  nodeUtils.setParameters(nodeCopy, null);
  nodeUtils.setChoices(nodeCopy, null);

  nodeUtils.updateNode(nodeCopy, idDestinationParent);
};

const updateReference = (node, nodeCopy) => {
  nodeUtils.addIdReference(node, nodeUtils.getID(nodeCopy));
};

//--------------------------------------------------------------------------------

const generatePayload = (
  node,
  index,
  nodeParent,
  indexDestination,
  nodeDestinationParent,
  nodeCopy,
  uuidReferences
) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    uuidDestinationParent: nodeUtils.getUUID(nodeDestinationParent),
    indexDestination: indexDestination,
    uuidCopy: nodeUtils.getUUID(nodeCopy),
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

  return `Add a new parameter and link it to global parameter '${nodeUtils.getName(node)}'.`;
}